module.exports = __webpack_public_path__ + "img/VertiHub-Logo.302f90d0.svg";